<template>
  <vx-card :title="title">
    <vs-row>
      <vs-col vs-w="6">
        <label for="">Territory</label>
        <Territory
          @data="setTerritory"
          :isMultiple="true"
          :isAllowEmpty="true"
        />
      </vs-col>
    </vs-row>
    <vs-row class="my-2">
      <vs-col vs-w="6">
        <vs-button type="filled" color="primary" icon="search" @click="getData"
          >Submit</vs-button
        >
      </vs-col>
    </vs-row>
    <div class="vx-row mb-12">
      <div class="core vx-col md:w-1/1 w-full mb-base">
        <vs-table
          search
          stripe
          border
          description
          :sst="true"
          :data="table.data"
          :max-items="table.length"
          :total="table.total"
          @search="onSearchTable"
        >
          <template slot="header">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ this.table.start }} - {{ this.table.end }} of
                  {{ this.table.total }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in table.limits"
                  :key="item"
                  @click="handleChangelength(item)"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <template slot="thead">
            <vs-th>Action</vs-th>
            <vs-th>Action Status</vs-th>
            <vs-th>No</vs-th>
            <vs-th>Collection Plan ID</vs-th>
            <vs-th>Collection Type</vs-th>
            <vs-th>Collection Date</vs-th>
            <vs-th>Operating Unit Territory</vs-th>
            <vs-th>Sales Name</vs-th>
            <vs-th># of Invoice</vs-th>
            <vs-th>Total Invoice</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="whitespace-no-wrap">
                <div class="vx-row gap-2">
                  <vs-button
                    @click="onClickShow(tr.id)"
                    size="small"
                    color="success"
                    icon-pack="feather"
                    icon="icon-eye"
                  />
                </div>
              </vs-td>
              <vs-td>
                <vs-button
                  @click="handleStatus(data[indextr].id, 1)"
                  size="small"
                  color="primary"
                  style="margin-right: 5px"
                  >Approve</vs-button
                >
                <vs-button
                  @click="handleStatus(data[indextr].id, 99)"
                  size="small"
                  color="danger"
                  style="margin-right: 5px"
                  >Reject</vs-button
                >
              </vs-td>
              <vs-td>{{ table.rowNumberStart + indextr }}</vs-td>
              <vs-td>{{ tr.uuid }}</vs-td>
              <vs-td>{{ tr.type }}</vs-td>
              <vs-td>{{ tr.date | formatDate }}</vs-td>
              <vs-td>{{ tr.operating_unit_territory }}</vs-td>
              <vs-td>{{ tr.sales_name }}</vs-td>
              <vs-td>{{ tr.count_invoice }}</vs-td>
              <vs-td>{{ tr.total_value | formatNumber }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
          style="padding-top: 5px"
          :total="table.totalPage"
          v-model="setPage"
        />
      </div>
    </div>
  </vx-card>
</template>
<script>
import moment from "moment";
import { formatNumber } from "../../../utils/common";
import Territory from "@/components/master/TerritoryV2.vue";

export default {
  components: {
    Territory,
  },
  data() {
    return {
      title: "Collection Plan List (New)",
      baseUrl: "api/sfa/v1/collection-plan/list-collection-plan",
      table: {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalpage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
        rowNumberStart: 1,
        territory_ids: [],
      },
    };
  },
  filters: {
    formatNumber(val) {
      if (val) {
        return formatNumber(val);
      }
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YYYY");
      }
    },
  },
  methods: {
    async setTerritory(datas) {
      this.table.territory_ids = [];
      await datas.forEach((data) => {
        this.table.territory_ids.push(data.id);
      });
    },
    async onSearchTable(search) {
      this.table.search = search;
      this.table.page = 1;
      this.getData();
    },
    async handleStatus(id, status) {
      this.$vs.loading();
      let response = await this.$http.put(
        `api/sfa/v1/collection-plan/${id}/status`,
        {
          status: status,
        }
      );

      if (response.code == 200) {
        this.$vs.notify({
          title: "Success",
          text: "Success update status",
          color: "success",
        });
        this.getData();
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Error update status",
          color: "danger",
        });
      }

      this.$vs.loading.close();
    },
    handleEdit(id) {
      this.$router.push({
        name: "collection-plan-edit",
        params: { id: id },
      });
    },
    handleShow(id) {
      this.$router.push({
        name: "collection-plan-show",
        params: { id: id },
      });
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.detail = false;
    },
    handleCreate() {
      this.id = null;
      this.detail = true;
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl, {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            status: 0,
            is_partial_waiting_list: true,
            is_waiting_list: true,
            territory_ids: this.table.territory_ids,
          },
        })
        .then((resp) => {
          if (resp.status == "OK") {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.rowNumberStart = resp.data.row_number_start;
            if (resp.data.records == null) {
              this.table.data = [];
            } else {
              this.table.data = resp.data.records;
            }
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            console.log(resp.data);
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch < this.table.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleDelete(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Please confirm to delete this data",
        accept: this.acceptDelete,
      });
    },
    onClickShow(id) {
      this.$router.push({
        name: "collection-plan-show-approval",
        params: { id: id },
      });
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
